module.exports = __webpack_public_path__ + "static/solution-section-firewall-tab-4d1199937b6efbbfcda802732d98df6b.webp";